export enum CheckoutSteps {
  Home = 0,
  Cart = 1,
  Information = 2,
  Shipping = 3,
  Payment = 4,
  Review = 5,
  Processing = 6,
  Confirmation = 7
}
